module.exports = __webpack_public_path__ + "static/media/likes-imgx.fb31fd41.png";